export default __webpack_public_path__ + "static/media/Taskmo-Corporate-Details.bb77325a.zip";